import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";

import { useUser } from "../../globals/UserContext.js";
import { Grid } from "@mui/material";
import { useClass, useSetClass } from "../../globals/ClassContext.js";
import { fetchClassAction } from "../../actions/fetchClass.js";

export default function ClassNav() {
  const user = useUser();
  const classroom = useClass();
  const classes = user.classes;

  const setClass = useSetClass()

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    const newClassID = (typeof classes[index] === "string") ? classes[index] : classes[index]._id
    fetchClassAction(newClassID, setClass)
    // setClass(classes[index]);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid item>
      <Button
        variant="contained"
        color="gray"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{marginRight: "10px"}}
        onClick={handleClick}
      >
        {Object.keys(classroom).length > 0 ? classroom.name : "All assignments"}
      </Button>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        <MenuItem
          key="all_assignments"
          selected={Object.keys(classroom).length === 0}
          onClick={(event) => {setClass({}); handleClose()}}
        >
          All Assignments
        </MenuItem>
        {classes.map((classOption, index) => (
          <MenuItem
            key={classOption._id}
            selected={classOption === classroom}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {classOption.name}
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
}
